var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import SubmitServiceApi from '~/api/submission-engine/submitService';
import { keysToCamel } from '~/utils/toCamelCase';
const submitFile = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const fileUploadResponse = keysToCamel(yield SubmitServiceApi.fetchFileUpload(file.name));
    if (!fileUploadResponse.txId) {
        throw Error(`Missing Tx ID in response for ${file.name}`);
    }
    if (!fileUploadResponse.uploadUrl) {
        throw Error(`Missing Upload URL in response for ${file.name}`);
    }
    const formData = new FormData();
    formData.append('file', file);
    const uploadResponse = yield fetch(fileUploadResponse.uploadUrl, { method: 'PUT', body: formData });
    if (!uploadResponse || uploadResponse.status !== 200) {
        throw Error('Failed to upload file to S3');
    }
    const triggerResponse = keysToCamel(yield SubmitServiceApi.triggerSubmission(fileUploadResponse.txId));
    if (triggerResponse.error_code) {
        throw Error(`Received Error Triggering Submission (${triggerResponse.error_code})`
            + `: ${triggerResponse.error_description}`);
    }
    return fileUploadResponse.txId;
});
export default submitFile;
